import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import avatar from '../../Pics/avatar.jpg'

import SpecificComponent from '../SpecificComponent'
import { Fab, FormControl, InputLabel, Select, MenuItem, Input, Grid, Checkbox, Divider } from '@material-ui/core';
import Utils from '../../providers/Utils';
import PropTypes from 'prop-types';
import Ws from '../../providers/Ws';
import OpenAddFisaPostului from './OpenAddFisaPostului';
import OpenAddCV from './OpenAddCV';
import ListTimpiLucru from '../ListTimpiLucru';
import FromServer from '../../module/projects/FromServer';


export default class TimpiLucru extends SpecificComponent {

    constructor(props) {
        super(props)
        this.state = {
            isOpenFisa: false,
            isOpenCv: false
        }
    }


    handleZileCumulate = async(z) =>{
    

        let zile = 0

        if(z.zile_cumulate === 1){
            zile = 0
        }else{
            zile = 1
        }

        let where = {
            id:z.id
        }
        let objToUpdate = {
            zile_cumulate:zile
        }

        let fs = new FromServer();

        let update = await fs.updateTaskuriTimpiLucru(objToUpdate, where)


// console.log('update :', update);
        if(update.Succes){
                this.props.getTimpiLucru()
        }

        // console.log('object :', objToUpdate);
    }



  
    render() {
        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    fullWidth={true}
                    maxWidth={'md'}
                    style={{
                        zIndex: 6000,
                    }}
                >

                    <DialogActions>
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>clear</i>
                        </Fab>
                    </DialogActions>

                    <h2 style={{ marginBottom: 5 }} className="pm-title">{this.props.task.nume}</h2>
                 <div style={{textAlign:'center'}}>
                 <Checkbox style={{ color: '#000000', padding: 0, display:'inline-block', width:'fit-content' }}
                                onChange={(ev) => { this.props.changeZileCumulate(ev) }}
                                checked={this.props.timpLucru.zile_cumulate === 1 ? true : false} />
                                        <span 
                                        className='pm-title'
                                        style={{display:'inline-block'}}>Zile Cumulate</span>

                 </div>
                            
                    <DialogContent style={{ width: '90%', margin: 'auto', overflow: 'hidden' }}>
                        <Grid style={{ width: '90%', margin: 'auto' }} container >
                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >


                                <TextField
                                disabled={this.props.timpLucru.zile_cumulate === 1 ? true : false}
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.proiecte.etapeProiect.data}
                                    value={this.props.timpLucru.data_introdusa || ''}
                                    onChange={this.props.changeData('data_introdusa')}
                                    margin="normal"
                                    type='date'
                                    InputLabelProps={{
                                        shrink:true
                                    }}
                                />
                            </Grid>

                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    multiline
                                    label={this.props.limba.proiecte.etapeProiect.ore}
                                    value={this.props.timpLucru.nr_ore || ''}
                                    onChange={this.props.changeData('nr_ore')}
                                    margin="normal"
                                    type='number'
                                    min='1'
                                    max='1000'
                                />

                            </Grid>
                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.proiecte.etapeProiect.minute}
                                    value={this.props.timpLucru.nr_minute || ''}
                                    onChange={this.props.changeData('nr_minute')}
                                    margin="normal"
                                    type='number'
                                    max='60'
                                    min='1'
                                />

                            </Grid>
                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                             <Button style={{ margin: 'auto' }} variant="outlined" onClick={() => { this.props.insertTimpLucru(this.props.timpLucru) }} className='pm-save-button'>
                            {this.props.limba.comune.add}
                        </Button>
                        </Grid>
                         
                        </Grid>


                    </DialogContent>

                    <DialogContent>
                        <h3 className='pm-title'>Lista Timpi Lucru</h3>
                        <Divider className='pm-divider'/>

                        <ListTimpiLucru
                            elemente={this.props.timpiLucru}
                            dict={this.props.limba}
                            onlyColumns={{zile_cumulate:'zile_cumulate',
                                        data_introdusa:'data_introdusa',
                                        nr_ore:'nr_ore',
                                        nr_minute:'nr_minute'}}
                            handleZileCumulate={this.handleZileCumulate} 
                            changeDate={this.props.changeDate}
                            updateDate={this.props.updateDateTimpi}
                            changeOre={this.props.changeOreTimpi}
                            updateOre={this.props.updateOreTimpi}
                            changeMinute={this.props.changeMinuteTimpi}
                            updateMinute={this.props.updateMinuteTimpi}
                            deleteTimp ={this.props.deleteTimp}
                        />
                    </DialogContent>

                    <DialogActions>


                       
                    </DialogActions>

                </Dialog>



           



            </div>

        );
    }


}  // end class

TimpiLucru.propTypes={
    getTimpiLucru:PropTypes.func,
    open:PropTypes.bool,
    dialogClose:PropTypes.func,
    task:PropTypes.object,
    changeZileCumulate:PropTypes.func,
    timpiLucru:PropTypes.array,
    changeData:PropTypes.func,
    limba:PropTypes.object,
    insertTimpLucru:PropTypes.func,
    changeDate:PropTypes.func,
    updateDateTimpi:PropTypes.func,
    changeOreTimpi:PropTypes.func,
    updateOreTimpi:PropTypes.func,
    changeMinuteTimpi:PropTypes.func,
    updateMinuteTimpi:PropTypes.func,
    deleteTimp:PropTypes.func
    

}